<template lang="pug">
  v-card
    v-card-text
      .d-flex
        div
          h2.mt-2 {{ title }}
          p.mt-2 {{ subject.title || subject.name }}
        v-spacer
        div
          tooltip-wrap(
            :text="subject.chat_room ? 'Открыть консультацию' : 'Консультации нет'"
          )
            v-btn(
              rounded
              depressed
              fab
              :disabled="!subject.chat_room"
              color="secondary"
              @click="subject.openChatAsTeacher({ replyTo: student })"
            )
              v-icon mdi-message-text
      .mx-n9.my-4
        v-progress-linear(
          color="secondary"
          height="10"
          value="40"
          :value="progress"
        )
      template(v-if="!loading")
        div(
          v-for="(task, idx) in tasks"
          :key="task.id"
        )
          v-row(
            no-gutters
            align="center"
          ).task.nowrap
            div
              p.pre-wrap: strong {{ task.title }}
              v-chip(
                small :color="$conf.TASK_STATUS_COLORS[task.status]"
              ).mb-4 {{ $conf.TASK_STATUS_NAMES[task.status] }}

              .lesson-content(v-if="task.attempt !== null")
                | Использовано попыток
                |  {{ task.user_attempts === null ? '0' : task.user_attempts }}
                |  из {{ task.attempt }}
            v-spacer
            .text-center(
              v-if="task.status === $conf.TASK_STATUSES.notChecked"
            )
              v-btn(
                fab
                text
                :to="toCheckTaskLink(task)"
              )
                v-icon(large) mdi-file-sign
              .caption Проверить
            .text-center(
              v-if="[$conf.TASK_STATUSES.fail, $conf.TASK_STATUSES.success].includes(task.status)"
            )
              v-btn(
                fab
                text
                @click="showJournal(task)"
              )
                v-icon(large) mdi-file-eye-outline
              .caption Результаты
          v-divider.my-5(v-if="idx !== tasks.length - 1")
      v-alert(
        v-if="!tasks.length && !loading"
        color="primary"
        text
      )
        v-icon(color="primary").mr-2 mdi-information
        span Заданий не предусмотрено
      v-skeleton-loader(
        v-if="loading"
        type="list-item@6"
      )
</template>

<script>
import Course from '@/models/list/Course';
import Unit from '@/models/list/Unit';

import JournalsList from '@/modules/Education/Courses/components/JournalsList.vue';

import { SUBJECT_TYPES } from '../constants';

export default {
  props: {
    subject: { type: Object, required: true },
    student: { type: Object, required: true },
  },
  data: () => ({
    tasks: [],
    loading: false,
  }),
  computed: {
    title() {
      const TITLES = {
        [SUBJECT_TYPES.course]: 'Курсовые работы',
        [SUBJECT_TYPES.unit]: 'Тематические задания',
        [SUBJECT_TYPES.lesson]: 'Задания урока',
      };
      return TITLES[this.subjectType];
    },
    subjectType() {
      if (this.subject instanceof Course) {
        return SUBJECT_TYPES.course;
      }
      if (this.subject instanceof Unit) {
        return SUBJECT_TYPES.unit;
      }
      return SUBJECT_TYPES.lesson;
    },
    progress() {
      if (!this.tasks.length) return 0;
      const successed = this.tasks.filter((t) => t.status === this.$conf.TASK_STATUSES.success);
      return (100 / this.tasks.length) * successed.length;
    },
  },
  watch: {
    subject: {
      handler() {
        this.fetchTasks();
      },
      immediate: true,
    },
  },
  methods: {
    showJournal(task) {
      this.$modals.show('generic-controller', {
        component: JournalsList,
        title: 'Список попыток',
        'component-props': {
          task,
          'user-id': this.student.id,
          'is-consult': true,
        },
      });
    },
    toCheckTaskLink(task) {
      const [studentGroup] = this.student.groups;
      return {
        name: 'TaskCheck',
        params: { id: task.id },
        query: { group: studentGroup.id, user: this.student.id },
      };
    },
    async fetchTasks() {
      this.loading = true;
      const API = {
        [SUBJECT_TYPES.course]: () => this.$api.users.coursesTasks(
          this.student.id, this.subject.id,
        ),
        [SUBJECT_TYPES.unit]: () => this.$api.users.unitsTasks(
          this.student.id, this.subject.course_id, this.subject.id,
        ),
        [SUBJECT_TYPES.lesson]: () => this.$api.users.lessonsTasks(
          this.student.id, this.subject.course_id, this.subject.course_unit_id, this.subject.id,
        ),
      };
      const { items } = await API[this.subjectType]();
      this.tasks = items;
      this.loading = false;
    },
  },
};
</script>
